import React, {Component} from 'react';
import ExcelExporter from "../../components/ExcelExporter";
import NavBarKS from "../../components/NavBarKS";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Table from "../../components/Table/Table";
import {request} from "../../helper/APIUtils";
import {hasUserRight, showAxiosError} from "../../helper/helper";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import moment from "moment";
import CustomerRequestMessageModal from "./CustomerRequestMessageModal";
import RequestMessageModal from "../requestmessage/RequestMessageModal";
import {UserRightsEnum} from "../../helper/enums";
import StickButton from "../../components/StickButton";
import CreateEditCustomerRequestModal from "./CreateEditCustomerRequestModal";
import Alert from "react-s-alert";
import UnReadCount from "./UnReadCount";

class CustomerRequestList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            total: 0,
            manual: false,
            content: [],
            loading: false,
            selection: [],
            searchQuery: undefined,
            chatModal: false,
            selectedRequest: {subject: "", subjectType: "", receiverId: null},
            section: "message",
            createEditModal: false,
            processType: "",
            services: [],
            serviceList: []
        }
        this.fetchData = this.fetchData.bind(this);
        this.openChatModal = this.openChatModal.bind(this);
        this.closeChatModal = this.closeChatModal.bind(this);
        this.closeCreateEditModal = this.closeCreateEditModal.bind(this);
        this.requestDone = this.requestDone.bind(this);
        this.fetchService = this.fetchService.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.messageModalToCreateModal = this.messageModalToCreateModal.bind(this);
        this.requestAssignToCurrentUser = this.requestAssignToCurrentUser.bind(this);
    }

    componentDidMount() {
        this.fetchService();
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=createdAt,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: '/requestForm/getRequestForm' + '?page=' + page + '&size=' + size  + searchQuery,
            method: "get"
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                    searching: false
                });
                self.props.reload(false);
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            self.props.reload(false);
            showAxiosError(error);
        });
    }

    isSelected(id) {
        return (this.state.selection.indexOf(id) !== -1);
    }

    getTrStyles(row) {
        return {backgroundColor: (this.isSelected(row.recordId) ? "#ffc" : "#f9f9f9")};
    }

    openChatModal(row) {
        let self = this;
        self.setState({selectedRequest: row, section: "message", chatModal: true});
    }

    closeChatModal() {
        let self = this;
        self.setState({chatModal: false});
        this.fetchData(undefined, undefined, this.state.page, this.state.size);
    }

    closeCreateEditModal(chatModal, requestForm) {
        let self = this;
        if (chatModal)
            self.setState({selectedRequest: requestForm});
        self.setState({createEditModal: false, chatModal});
        this.fetchData(undefined, undefined, this.state.page, this.state.size);
    }

    handleCreate() {
        let self = this;
        let selectedRequest = {subject: "", subjectType: "", receiverId: null};
        self.setState({createEditModal: true, selectedRequest, processType: "create"});
    }

    handleEdit(row) {
        let self = this;
        let selectedRequest = row;
        self.setState({processType: "edit", selectedRequest, createEditModal: true});
    }
    messageModalToCreateModal(){
        let self = this;
        self.setState({chatModal: false});
        self.handleCreate();
    }

    requestDone(row) {
        let self = this;
        row.status = "CLOSED";
        let params = {
            url: '/requestForm/closeRequest?recordId=' + row.recordId,
            method: "post"
        };
        request(params).then(function (response) {
            Alert.success('İstek başarılı bir şekilde kapatılmıştır.', {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
            ;
        }).catch(function (error) {
            showAxiosError(error);
        })
        self.fetchData(undefined, undefined, self.state.page, self.state.size)

    }

    getStatusInfo(status, type) {
        switch (status) {
            case "WAITING":
                return type === 'style' ? 'mt-auto mb-auto text-danger' : 'Cevap Bekleniyor';
            case "ANSWERED":
                return type === 'style' ? 'mt-auto mb-auto text-warning' : 'Cevap verildi';
            case "CLOSED":
                return type === 'style' ? 'mt-auto mb-auto text-success' : 'Kapatıldı';
            default:
                return '';
        }
    }

    fetchService() {
        let self = this;
        let params = {
            url: "/requestForm/getServices",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let services = response.data;
                services.push({ublCode:"Diğer",ublName:"DIGER"});
                services.push({ublCode:"Tümü",ublName:null});
                let serviceList = services.map(service => ({
                    value: service.ublName,
                    label: service.ublCode
                }));
                self.setState({serviceList});
            }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({loading: false});
        });
    }

    showSubjectType(subjectType){
        let self = this;
        let services = self.state.services;
        return  services.find(service => service.ublCode === subjectType).ublName;
    }

    handleSearch(searchQuery) {
        this.setState({searchQuery, searching: true}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    requestAssignToCurrentUser(item){
        let self = this;
        item.receiverId = self.props.currentUser.id;
        item.receiverUsername = self.props.currentUser.username;
        let params = {
            url: '/requestForm/save',
            method: "post",
            data: item
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                Alert.success('Talep atanmıştır.', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
                self.setState({loading: false});
            }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }



    render() {
        const columns = [
            {
                Header: "VKN/TCKN",
                accessor: "vknTckn",
                Cell: row => (
                    <div><TextOverFlowTooltip text={row.customerVknTckn} maxLength={23}></TextOverFlowTooltip></div>)
            },
            {
                Header: "Müşteri Adı",
                accessor: "customerName",
                Cell: row => (
                    <div><TextOverFlowTooltip text={row.formattedName} maxLength={23}></TextOverFlowTooltip></div>)
            },
            {
                Header: "Konu Tipi",
                accessor: "subjectType",
                Cell: row => (
                    <div><TextOverFlowTooltip text={row.subjectType} maxLength={23}></TextOverFlowTooltip></div>
                )
            },
            {
                Header: "Konu",
                accessor: "subject",
                Cell: row => (
                    <div><TextOverFlowTooltip text={row.subject || ""} maxLength={23}></TextOverFlowTooltip></div>)
            },
            {
                Header: "Talep Durumu",
                accessor: "statusMessage",
                Cell: row => (
                    <div>
                        <p className={this.getStatusInfo(row.status, "style")}>{this.getStatusInfo(row.status, "text")}</p>
                        <UnReadCount requestId={row.recordId}/>
                    </div>
                )
            },
            {
                Header: "Talep Tarihi",
                accessor: "createdAt",
                Cell: row => (<div>{(row.createdAt ? moment(row.createdAt).format("DD-MM-YYYY HH:mm:ss") : "-")}</div>)
            },

            /*{
                Header: "Cevap Tarihi",
                accessor: "answerAt",
                Cell: row => (<div>{(row.answerAt ? moment(row.answerAt).format("DD-MM-YYYY HH:mm:ss") : "-")}</div>)
            },*/
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <div className="btn-group">
                        <div className="dropdown">
                            <button className="MenuBtn2 listt btn btn-default" type="button"
                                    data-toggle="dropdown"> Seçİnİz
                            </button>
                            <div className="dropdown-menu">
                                <a className="dropdown-item"
                                   onClick={(e) => this.openChatModal(row)}>
                                    <i className=" fa fa-eye"/>Talebi Görüntüle
                                </a>
                                <a className="dropdown-item"
                                   onClick={(e) => this.handleEdit(row)}>
                                    <i className="fa fa-edit"/>Talebi Düzenle
                                </a>
                                {
                                    this.props.currentUser.vknTckn === "5750464002" && row.receiverId === null&&
                                    <a className="dropdown-item"
                                       onClick={()=>this.requestAssignToCurrentUser(row)}>
                                        <i className="fas fa-thumbtack"/>Talebi Kendine Ata
                                    </a>
                                }
                                {
                                    this.props.currentUser.vknTckn === "5750464002"&& row.status !== "CLOSED" &&
                                    <a className="dropdown-item"
                                       onClick={(e) => this.requestDone(row)}>
                                        <i className="fas fa-check"/>Talebi Sonlandır
                                    </a>
                                }


                            </div>
                        </div>
                    </div>
                )
                    /*<div className="col">
                        <div className="row">
                            <button type="button"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    onClick={(e) => this.openChatModal(row)}
                                    title="Göster"
                                    style={{background: 'orange'}} rel="tooltip"
                                    className="Btn btn-icon">
                                <i className="BtnIcon fa fa-eye"/>
                            </button>
                            <button
                                type="button"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                onClick={(e) => this.handleEdit(row)}
                                title="Düzenle"
                                style={{background: "linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))"}}
                                rel="tooltip"
                                className="Btn btn-icon">
                                <i className="fa fa-edit"/>
                            </button>
                            {
                                this.props.currentUser.vknTckn === "5750464002"&&
                                <button
                                    type="button"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    onClick={()=>this.requestAssignToCurrentUser(row)}
                                    title="Kendine Ata"
                                    style={{background: "linear-gradient(rgb(195 18 18), rgb(195 18 18))"}} rel="tooltip"
                                    className="Btn btn-icon">
                                    <i className="fas fa-thumbtack"></i>
                                </button>
                            }
                            {this.props.currentUser.vknTckn === '5750464002' &&
                            <button
                                type="button"
                                data-toggle="tooltip"
                                data-placement="bottom"
                                onClick={(e) => this.requestDone(row)}
                                title="Tamamlandı"
                                style={{background: "linear-gradient(rgb(115 199 54), rgb(120 215 120))"}} rel="tooltip"
                                className="Btn btn-icon">
                                <i className="fas fa-check"></i>
                            </button>
                            }

                        </div>
                    </div>)*/
            }
        ];
        const fields = [
            {
                label: "Müşteri Adı",
                accessor: "formattedName",
                type: "text",
                operator: "=",
            },
            {
                label: "VKN/TCKN",
                accessor: "customerVknTckn",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Talep Durumu",
                accessor: "status",
                type: "select",
                operator: "=",
                selectData: [
                    {label:"Cevap Bekleniyor",value:"WAITING"},
                    {label:"Cevap verildi",value:"ANSWERED"},
                    {label:"Kapatıldı",value:"CLOSED"},
                    {label: "Tümü", value: null}
                ]
            },
            {
                label: "Konu Tipi",
                accessor: "subjectType",
                type: "select",
                operator: "=",
                selectData: this.state.serviceList
            },
            {
                label: "Oluşturulma Tarihi (Başlangıç)",
                accessor: "min_createdAt",
                type: "datetime",
                operator: ">=",
            },
            {
                label: "Oluşturulma Tarihi (Bitiş)",
                accessor: "max_createdAt",
                type: "datetime",
                operator: "<=",
            }
        ];

        return (
            <div className="row baseBackground">
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name="requestMessageList">
                    {this.props.currentUser.vknTckn !== '5750464002' &&
                    <StickButton position="leftSide"
                                 onClick={() => this.handleCreate()}
                                 label="Yeni Oluştur"
                                 title="Yeni Oluştur"
                        /*disabled={(this.props.profileId === "EFATURA") ? !hasUserRight(UserRightsEnum.invoice.create,this.props.currentUser) : !hasUserRight(UserRightsEnum.earchive.create,this.props.currentUser)}*/
                                 className="stickButton plus-circle"
                                 icon="plus-circle"/>
                    }
                </NavBarKS>

                <div className="col-sm-12 satirBasi">
                    <div className="card-header">
                        <h4 className="card-title">Müşteri İstek/Talep Takibi</h4>
                    </div>
                    <div className="card-body">
                        <DetailedSearch fields={fields}
                                        loading={this.state.searching}
                                        onSearch={this.handleSearch}/>
                    </div>
                    <div className="card-body">
                        <Table columns={columns}
                               loading={this.state.loading}
                               loadingText="Kayıtlar getiriliyor..."
                               content={this.state.content}
                               total={this.state.total}
                               page={this.state.page}
                               manual={this.state.manual}
                               size={this.state.size}
                               options={["5", "10", "20", "50", "100", "250"]}
                               fetchData={this.fetchData}
                               getTrClass={this.getTrClass}
                        />
                    </div>
                </div>
                {
                    this.state.chatModal &&
                    <CustomerRequestMessageModal
                        modal={this.state.chatModal}
                        close={this.closeChatModal}
                        selected={this.state.selectedRequest}
                        currentUser={this.props.currentUser}
                        section={this.state.section}
                        messageToCreate = {this.messageModalToCreateModal}

                    />
                }
                {
                    this.state.createEditModal &&
                    <CreateEditCustomerRequestModal
                        modal={this.state.createEditModal}
                        closeModal={this.closeCreateEditModal}
                        selectedRequest={this.state.selectedRequest}
                        currentUser={this.props.currentUser}
                        type={this.state.processType}
                    />
                }
            </div>
        );
    }
}

export default CustomerRequestList;